import { Component } from "@angular/core";

@Component({
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.css'],
    selector: 'app-footer'
})
export class FooterCompnent {
    Year: number = new Date().getFullYear();
}